import PageHero from '@components/common/PageHero'

const FAMILY = "'DM Sans', sans-serif"
const AMBER  = '#ed9716'
const TEXT   = '#2d2d2d'

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: '36px' }}>
      <h2 style={{
        fontFamily: FAMILY, fontSize: '11px', fontWeight: 700,
        letterSpacing: '0.13em', textTransform: 'uppercase',
        color: AMBER, margin: '0 0 10px',
      }}>
        {title}
      </h2>
      <div style={{ width: '24px', height: '2px', background: AMBER, marginBottom: '16px' }} />
      {children}
    </div>
  )
}

function P({ children }) {
  return (
    <p style={{
      fontFamily: FAMILY, fontSize: '14.5px', color: TEXT,
      lineHeight: 1.85, margin: '0 0 14px',
    }}>
      {children}
    </p>
  )
}

function UL({ items }) {
  return (
    <ul style={{ margin: '0 0 14px', paddingLeft: '20px' }}>
      {items.map((item, i) => (
        <li key={i} style={{
          fontFamily: FAMILY, fontSize: '14.5px', color: TEXT,
          lineHeight: 1.85, marginBottom: '6px',
        }}>
          {item}
        </li>
      ))}
    </ul>
  )
}

export default function PrivacyPolicyPage() {
  return (
    <>
      <PageHero
        title="Privacy Policy"
        breadcrumbs={[
          { label: 'Home', to: '/' },
          { label: 'Privacy Policy' },
        ]}
      />

      <div style={{ background: '#ffffff' }}>
        <div style={{
          maxWidth: 'var(--container-max)', margin: '0 auto',
          padding: '60px var(--container-padding) 80px',
        }}>
          <p style={{
            fontFamily: FAMILY, fontSize: '13.5px', color: '#888',
            marginBottom: '48px',
          }}>
            Last updated: April 2025
          </p>

          <Section title="Introduction">
            <P>
              Salient Agrinutrition Pvt. Ltd. ("we", "us", or "our") operates the website
              salientagrinutrition.com. This Privacy Policy explains how we collect, use, and
              protect information when you visit our website or contact us through it.
            </P>
            <P>
              By using this website, you agree to the practices described in this policy. If you
              do not agree, please refrain from using the site.
            </P>
          </Section>

          <Section title="Information We Collect">
            <P>We may collect the following types of information:</P>
            <UL items={[
              'Contact information you provide voluntarily — such as your name, email address, phone number, and message — when you submit our contact form.',
              'Technical data automatically collected when you browse the site, including your IP address, browser type, pages visited, and time spent on pages (via analytics tools).',
              'Cookies and similar tracking technologies used to understand how visitors interact with our website.',
            ]} />
          </Section>

          <Section title="How We Use Your Information">
            <P>The information we collect is used to:</P>
            <UL items={[
              'Respond to your enquiries submitted via the contact form.',
              'Improve the content, structure, and usability of our website.',
              'Analyse traffic patterns and understand visitor behaviour through aggregated analytics data.',
              'Comply with legal obligations where applicable.',
            ]} />
            <P>
              We do not sell, rent, or trade your personal information to third parties for
              marketing purposes.
            </P>
          </Section>

          <Section title="Cookies">
            <P>
              Our website may use cookies — small text files stored on your device — to improve
              your browsing experience and gather anonymous usage statistics. You can control or
              disable cookies through your browser settings. Disabling cookies may affect some
              features of the site.
            </P>
          </Section>

          <Section title="Third-Party Links">
            <P>
              Our website may contain links to external websites (such as supplier websites or
              social media platforms). We are not responsible for the privacy practices or
              content of those sites. We encourage you to review their privacy policies
              independently.
            </P>
          </Section>

          <Section title="Data Security">
            <P>
              We take reasonable technical and organisational measures to protect the information
              we collect against unauthorised access, loss, or misuse. However, no method of
              transmission over the internet is completely secure, and we cannot guarantee
              absolute security.
            </P>
          </Section>

          <Section title="Data Retention">
            <P>
              Contact form submissions are retained only as long as necessary to respond to your
              enquiry or as required by applicable law. Analytics data is retained in aggregated,
              anonymised form.
            </P>
          </Section>

          <Section title="Contact Us">
            <P>
              If you have any questions about this Privacy Policy or how your information is
              handled, please contact us:
            </P>
            <UL items={[
              'Email: info@salientagrinutrition.com',
              'Phone: +94 718 919 034',
              'Address: No.51/D, P.T.S. Avenue, Dalugama, Kelaniya, Sri Lanka',
            ]} />
          </Section>
        </div>
      </div>
    </>
  )
}
